import React from "react";
import {Card as CardReactStrap, CardBody, CardHeader, CardTitle} from "reactstrap";

const Card = ({title, children, ...rest}) =>
    <CardReactStrap className="card-chart" {...rest}>
        <CardHeader>
            <CardTitle tag="h4">{title}</CardTitle>
        </CardHeader>
        <CardBody>
            {children}
        </CardBody>
    </CardReactStrap>;

export default Card;